import React from 'react';
import { Input } from './ui/input';

/**
 * Brazilian currency masked input.
 * Internally stores number (BRL). Displays formatted "1.234,56".
 * User-friendly: types digits, last 2 are cents.
 */
export default function CurrencyInput({ value, onChange, placeholder, ...rest }) {
  const display =
    value === '' || value === null || value === undefined
      ? ''
      : Number(value).toLocaleString('pt-BR', {
          minimumFractionDigits: 2,
          maximumFractionDigits: 2,
        });

  const handleChange = (e) => {
    const digits = e.target.value.replace(/\D/g, '');
    if (!digits) {
      onChange('');
      return;
    }
    // Limit to 13 digits (= 99.999.999.999,99 -> ~99 bi)
    const limited = digits.slice(0, 13);
    const num = parseInt(limited, 10) / 100;
    onChange(num);
  };

  const handleKeyDown = (e) => {
    // Allow numeric, navigation and edit keys
    if (
      e.key === 'Backspace' ||
      e.key === 'Delete' ||
      e.key === 'Tab' ||
      e.key === 'Enter' ||
      e.key.startsWith('Arrow') ||
      (e.ctrlKey || e.metaKey)
    ) return;
    if (!/^\d$/.test(e.key)) {
      e.preventDefault();
    }
  };

  return (
    <div className="relative">
      <span className="absolute left-3 top-1/2 -translate-y-1/2 text-xs text-muted-foreground pointer-events-none">R$</span>
      <Input
        type="text"
        inputMode="numeric"
        autoComplete="off"
        className="pl-9 text-right tabular"
        value={display}
        placeholder={placeholder || '0,00'}
        onChange={handleChange}
        onKeyDown={handleKeyDown}
        {...rest}
      />
    </div>
  );
}
